var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconsFilterFitnessPlayerClassType = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-59349e77-daac-4a00-9c14-54c98d278853",
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.95,15.27c-.15-.62-.59-1.09-1.2-1.27,0,0,0,0,0,0l-2.82-.88-1.56-4.8s0,0,0,0c0,0,0,0,0,0-.24-.72-.82-1.27-1.56-1.48,0,0,0,0,0,0l-2.1-.6s0,0,0,0c0,0,0,0,0,0-1.6-.45-3.3-.52-4.93-.21-1.63,.31-3.19,1.01-4.51,2.01-.02,.02-.04,.03-.06,.05l-1.91,1.46s0,0,0,0c-.55,.4-.83,1.04-.75,1.72,.08,.69,.53,1.28,1.17,1.54,.23,.09,.47,.14,.71,.14,.42,0,.83-.14,1.17-.41,0,0,0,0,0,0l2.65-2.01s0,0,0,0c0,0,0,0,0,0,.49-.37,1.12-.52,1.74-.4,0,0,0,0,0,0s0,0,0,0l.32,.06-1.97,6.4s0,0,0,0c0,0,0,0,0,0-.08,.26-.19,.48-.33,.67l-2.94,3.88-3.24-1.55s0,0,0,0c0,0,0,0,0,0-.51-.24-1.08-.27-1.6-.09-.53,.18-.96,.56-1.2,1.07-.5,1.05-.05,2.31,.99,2.83,0,0,0,0,0,0,0,0,0,0,0,0l4.24,2.03s0,0,0,0c0,0,0,0,0,0,.39,.19,.82,.28,1.24,.28,.23,0,.45-.03,.67-.08,.64-.16,1.21-.53,1.61-1.06,0,0,0,0,0,0h0s0,0,0,0h0s3.61-4.77,3.61-4.77c0,0,0,0,0,0,0,0,0-.01,.01-.01l4.36,2.87v5.13s0,0,0,0c0,0,0,0,0,0,.01,.56,.24,1.08,.64,1.47,.4,.39,.92,.6,1.48,.6,1.15,0,2.07-.91,2.1-2.07,0,0,0,0,0,0,0,0,0,0,0,0v-5.84h0c0-.96-.48-1.86-1.3-2.39,0,0,0,0,0,0h0s0,0,0,0h0s-3.25-2.16-3.25-2.16c0,0,0,0,0,0,0,0,0,0,0,0-.01,0-.02-.02-.02-.02l.93-3.04,.18,.54s0,0,0,0c.22,.67,.75,1.19,1.42,1.39,0,0,0,0,0,0,0,0,0,0,0,0l3.77,1.14s0,0,0,0c.17,.05,.34,.08,.52,.08,.43,0,.86-.17,1.2-.48,.47-.44,.67-1.1,.53-1.73Zm-6.06,13.19c-.39,0-.7-.3-.71-.69v-5.34c0-.33-.17-.65-.45-.83,0,0,0,0,0,0,0,0,0,0,0,0l-4.55-2.99s0,0,0,0c-.63-.41-1.45-.27-1.91,.34,0,0,0,0,0,0h0s0,0,0,0h0s-3.61,4.77-3.61,4.77c0,0,0,0,0,0,0,0,0,0,0,0-.42,.56-1.16,.74-1.79,.44l-4.23-2.03c-.36-.17-.51-.6-.34-.96,.16-.34,.58-.48,.94-.32l3.54,1.69s0,0,0,0c0,0,0,0,0,0,.14,.06,.28,.1,.42,.1,.3,0,.6-.14,.8-.39,0,0,0,0,0,0l3.15-4.15s0,0,0,0c0,0,0,0,0,0,.25-.33,.43-.69,.56-1.11,0,0,0,0,0,0l2.1-6.83s0,0,0,0c0,0,0,0,0,0,.09-.29,.05-.59-.1-.84-.15-.24-.39-.4-.69-.46,0,0,0,0,0,0,0,0,0,0,0,0l-.76-.13s0,0,0,0c-1-.19-2.04,.06-2.84,.67,0,0,0,0,0,0l-2.65,2.01s0,0-.01,0c0,0,0,0-.01,0-.14,.11-.32,.14-.48,.07-.17-.07-.28-.22-.3-.4-.02-.18,.04-.33,.19-.43,0,0,0,0,0,0,0,0,0,0,.01,0l1.96-1.49s.03-.03,.05-.04c2.32-1.74,5.36-2.32,8.17-1.54l2.09,.6s0,0,0,0c0,0,0,0,0,0,.29,.08,.52,.29,.61,.57,0,0,0,0,0,0l1.63,5.02s0,0,0,0c0,0,0,0,0,0,.1,.3,.34,.53,.66,.63,0,0,0,0,0,0l3.01,.94s0,0,0,0c0,0,0,0,0,0,.13,.04,.21,.12,.24,.25,.03,.13-.01,.27-.11,.37-.11,.1-.22,.13-.34,.09,0,0,0,0,0,0,0,0,0,0,0,0l-3.77-1.14s0,0,0,0c-.23-.07-.42-.26-.5-.48,0,0,0,0,0,0l-.87-2.65s0-.01,0-.02c0-.01,0-.03-.01-.04,0-.01,0-.02-.01-.03,0,0,0-.02-.01-.03,0-.01-.01-.02-.02-.03,0,0-.01-.02-.02-.02,0-.01-.02-.02-.02-.03,0,0-.01-.02-.02-.02,0,0-.02-.02-.02-.03,0,0-.01-.02-.02-.02,0,0-.02-.02-.02-.02,0,0-.02-.02-.03-.02,0,0-.02-.01-.02-.02-.01,0-.02-.02-.03-.02,0,0-.02-.01-.03-.02-.01,0-.02-.01-.03-.02,0,0-.02,0-.03-.01-.01,0-.02,0-.03-.01-.01,0-.03,0-.04-.01,0,0-.01,0-.02,0,0,0,0,0,0,0-.01,0-.03,0-.05-.01,0,0-.02,0-.02,0-.01,0-.03,0-.04,0,0,0-.02,0-.02,0-.01,0-.03,0-.04,0,0,0-.02,0-.03,0-.01,0-.02,0-.03,0-.01,0-.02,0-.04,0,0,0-.02,0-.03,0-.01,0-.03,0-.04,0,0,0-.02,0-.03,0-.01,0-.03,0-.04,.01,0,0,0,0,0,0,0,0-.01,0-.02,0-.01,0-.02,0-.04,.01-.01,0-.02,.01-.03,.02,0,0-.02,0-.03,.01-.01,0-.02,.01-.03,.02,0,0-.02,0-.02,.01-.01,0-.02,.02-.03,.02,0,0-.01,.01-.02,.02,0,0-.02,.02-.03,.03,0,0-.02,.01-.02,.02,0,0-.02,.02-.02,.03,0,0-.02,.02-.02,.03,0,0-.01,.02-.02,.02,0,.01-.01,.02-.02,.03,0,0-.01,.02-.02,.03,0,.01-.01,.02-.02,.03,0,0,0,.02-.01,.03,0,.01,0,.02-.01,.03,0,.01,0,.03-.01,.04,0,0,0,.01,0,.02l-1.58,5.18s0,0,0,0c0,0,0,0,0,0-.18,.6,.06,1.24,.6,1.59,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0l3.25,2.16s0,0,0,0c0,0,0,0,0,0,.42,.27,.66,.73,.66,1.22v5.83c0,.39-.31,.69-.69,.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.88,5.98c1.61,0,2.92-1.31,2.92-2.92S24.49,.13,22.88,.13s-2.92,1.31-2.92,2.92,1.31,2.92,2.92,2.92Zm0-4.44c.84,0,1.52,.68,1.52,1.52s-.68,1.52-1.52,1.52-1.52-.68-1.52-1.52,.68-1.52,1.52-1.52Z"
  }))), /*#__PURE__*/React.createElement("line", {
    x1: 13.93,
    y1: 3.95,
    x2: 5.61,
    y2: 3.95,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.68px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.11,
    y1: 7.24,
    x2: 1.8,
    y2: 7.24,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.68px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.33,
    y1: 15.18,
    x2: 5.02,
    y2: 15.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.68px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.27,
    y1: 11.1,
    x2: 1.96,
    y2: 11.1,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.68px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.11,
    y1: 17.48,
    x2: 0.8,
    y2: 17.48,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.68px"
    }
  }));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconsFilterFitnessPlayerClassType, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icons_Filter_FitnessPlayer_ClassType.b6995a87.svg";
export { ForwardRef as ReactComponent };